import { FC } from 'react';
import Modal from 'components/layouts/modal';
import useApi from 'utils/use-api';
import { useMutation } from '@tanstack/react-query';

interface DeleteRoleProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  roleId?: number;
  onSuccess: () => void;
}

const DeleteRole: FC<DeleteRoleProps> = ({ open, setOpen, roleId, onSuccess }) => {
  const api = useApi();
  const deleteRoleMutation = useMutation({
    mutationFn: async () => {
      if (!roleId) return;
      const res = await api.delete(`/roles/${roleId}`);
      return res.data;
    },
    onSuccess: () => {
      onSuccess();
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Delete Role"
      description="Are you sure you want to delete this role?"
      size="4xl"
      renderActions={() => (
        <div className="flex gap-2 ml-3">
          <button
            type="button"
            onClick={() => deleteRoleMutation.mutate()}
            className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
          >
            Delete
          </button>
        </div>
      )}
    />
  );
};

export default DeleteRole;
